import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent py-5'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60 py-3'
      }`}
    >
      <div className="w-full px-4 md:px-6 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className={`font-heading text-xl md:text-2xl transition-colors duration-300 ${
            isHome && !scrolled ? 'text-background-50' : 'text-foreground-950'
          }`}>
            膀胱健康管理
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer relative group ${
                isHome && !scrolled
                  ? 'text-background-50/80 hover:text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950'
              } ${
                location.pathname === item.path
                  ? (isHome && !scrolled ? 'text-background-50' : 'text-foreground-950')
                  : ''
              }`}
            >
              {item.label}
              <span className={`absolute -bottom-1 left-0 h-0.5 transition-all duration-300 ${
                location.pathname === item.path
                  ? 'w-full'
                  : 'w-0 group-hover:w-full'
              } ${isHome && !scrolled ? 'bg-background-50' : 'bg-primary-500'}`}></span>
            </Link>
          ))}
          <Link
            to="/category"
            className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isHome && !scrolled
                ? 'bg-background-50/20 text-background-50 border border-background-50/30 hover:bg-background-50/30'
                : 'bg-primary-500 text-background-50 hover:bg-primary-600'
            }`}
          >
            开始学习
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-md ${
            isHome && !scrolled ? 'text-background-50' : 'text-foreground-950'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium py-2 cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-primary-600'
                    : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/category"
              className="px-4 py-2 rounded-md text-sm font-medium text-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              开始学习
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}